@if (hasPrimary && left.team && right.team) {
  <div class="team-card">
    <div class="side left">
      <div class="group">
        @if (left.team.code) {
          <span [class]="'fi-' + left.team.code" class="fib"></span>
        }
        <!-- <lib-bleachr-country-flags [country]="left.team.code" [width]="'68px'" height="auto"> </lib-bleachr-country-flags> -->
        <div class="name-and-pill">
          <div class="team-name">{{ tTeam(left.team) }}</div>
          @if (left.winner) {
            <div class="winner-pill" [style.backgroundColor]="left.team.color">
              <app-app-string key_name="golf.matchplay.team.winner"></app-app-string>
            </div>
          }
        </div>
      </div>
      @if (left.score) {
        <div
          class="score-pill large"
          [ngClass]="{ colored: !!left.team.color, neutral: !left.team.color }"
          [style.--pill-bg]="left.team.color || null"
          [attr.data-team]="left.team.code"
          >
          {{ left.score }}
        </div>
      }
    </div>
    <div class="divider" aria-hidden="true"></div>
    <div class="side right">
      @if (right.score) {
        <div
          class="score-pill large"
          [ngClass]="{ colored: !!right.team.color, neutral: !right.team.color }"
          [style.--pill-bg]="right.team.color || null"
          [attr.data-team]="right.team.code"
          >
          {{ right.score }}
        </div>
      }
      <div class="group" style="margin-left: auto">
        <div class="name-and-pill right">
          <div class="team-name">{{ tTeam(right.team) }}</div>
          @if (right.winner) {
            <div class="winner-pill" [style.backgroundColor]="right.team.color">
              <app-app-string key_name="golf.matchplay.team.winner"></app-app-string>
            </div>
          }
        </div>
        @if (right.team.code) {
          <span [class]="'fi-' + right.team.code" class="fib"></span>
        }
        <!-- <lib-bleachr-country-flags [country]="right.team.code" [width]="'68px'" height="auto"> </lib-bleachr-country-flags> -->
      </div>
    </div>
    @if (left.projected) {
      <div class="projected projected-left">
        {{ left.projectedText }}
      </div>
    }
    @if (right.projected) {
      <div class="projected projected-right">
        {{ right.projectedText }}
      </div>
    }
  </div>
}
